import { useTranslation } from 'react-i18next';
import React from 'react';
import { ENGLISH, SWEDISH, FINNISH, NORWEGIAN, ENGLISH_WITHOUT_REGION } from '../constants/LanguageCodes';
import { FINLAND, GREAT_BRITAIN, NORWAY, SWEDEN } from '../constants/CountryCodes';
import ReactFlagsSelect from 'react-flags-select';
import { isPageReloadOrRefresh, mapToLanguageCode } from '../utils';

export function getPersistedLanguage(kioskCountry) {
  const mapToCountryCode = languageCode => {
    switch (languageCode) {
    case ENGLISH:
      return GREAT_BRITAIN;
    case FINNISH:
      return FINLAND;
    case NORWEGIAN:
      return NORWAY;
    case SWEDISH:
      return SWEDEN;
    default:
      return GREAT_BRITAIN;
    }
  };

  // this is happening in the case that you are loggin and also if you refresh the page
  if (isPageReloadOrRefresh() && kioskCountry && !localStorage.getItem('language')) {
    return kioskCountry.toUpperCase();
  }
  const language = mapToCountryCode(localStorage.getItem('language'));

  return language.toUpperCase();
}

export function LanguageSelector({ kioskCountry }) {
  const { t, i18n } = useTranslation();

  function persistLanguage(selectedLanguage) {
    const language = mapToLanguageCode(selectedLanguage.toLocaleLowerCase());
    localStorage.setItem('language', language);
    i18n.changeLanguage(language);
  }

  return (
    <div role="group" aria-label={t('a11y.languageSelectorLabel')}>
      <ReactFlagsSelect
        selected={getPersistedLanguage(kioskCountry).toUpperCase()}
        onSelect={code => persistLanguage(code)}
        countries={[
          GREAT_BRITAIN.toUpperCase(),
          FINLAND.toUpperCase(),
          NORWAY.toUpperCase(),
          SWEDEN.toUpperCase(),
        ]}
        className="menu-flags"
        selectButtonClassName="menu-flags-button"
        customLabels={{
          GB: ENGLISH_WITHOUT_REGION.toUpperCase(),
          FI: FINNISH.toUpperCase(),
          NO: NORWEGIAN.toUpperCase(),
          SE: SWEDISH.toUpperCase() }}
      />
    </div>
  );
}

